var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { createContext, useState, useEffect } from 'react';
import useFetchState from '../hooks/useFetchState';
import { buildReturnLabelRequest } from '../utils/returns/returns-helper';
import { createHtmlContent, getErrorBySSRCode, openNativeAppLabel, openNewWindow, } from '../utils/returns/return-label';
import { useExperienceContext } from '../hooks/useContexts';
import { GetReturnShippingLabelAPI } from '../utils/returns/api-helpers';
var defaultState = {
    orderId: '',
    loading: false,
    error: null,
    lastClicked: '',
    fetchReturnLabel: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/];
    }); }); },
    returnLabelResponse: null,
    apiError: undefined,
    setAPIError: function () { },
    retryAvailable: true,
    setRetryAvailable: function () { },
    openNewReturnLabelWindow: function () { },
};
export var ReturnLabelContext = createContext(defaultState);
export var ReturnLabelProvider = function (_a) {
    var children = _a.children, orderId = _a.orderId, emailId = _a.emailId, trackingNumbers = _a.trackingNumbers, isGuest = _a.isGuest, net = _a.net, xAuthGuestToken = _a.xAuthGuestToken;
    var _b = useFetchState(), loading = _b.loading, fetchData = _b.fetchData, returnLabelResponse = _b.data, error = _b.error;
    var _c = useState(true), retryAvailable = _c[0], setRetryAvailable = _c[1];
    var _d = useState(), apiError = _d[0], setAPIError = _d[1];
    var _e = useState(''), lastClicked = _e[0], setLastClicked = _e[1];
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var isNativeApp = isConsumerApp || false;
    var request = buildReturnLabelRequest(orderId, emailId, trackingNumbers, isGuest, net);
    var fetchReturnLabel = function (type, openWindow) { return __awaiter(void 0, void 0, void 0, function () {
        var labelWindow, _a, data, fetchError, htmlLabel, errorInfo, htmlLabel;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLastClicked(type);
                    setAPIError(undefined);
                    labelWindow = null;
                    if (!isNativeApp && openWindow) {
                        labelWindow = openNewReturnLabelWindow();
                        if (labelWindow === null)
                            return [2 /*return*/];
                    }
                    if (!!returnLabelResponse) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetchData(function () {
                            return GetReturnShippingLabelAPI(request, xAuthGuestToken);
                        })];
                case 1:
                    _a = _b.sent(), data = _a.data, fetchError = _a.error;
                    if (data) {
                        setRetryAvailable(true);
                        if (type === 'barcode')
                            return [2 /*return*/];
                        htmlLabel = createHtmlContent(data, orderId);
                        if (isNativeApp) {
                            return [2 /*return*/, openNativeAppLabel(htmlLabel)];
                        }
                        if (labelWindow) {
                            return [2 /*return*/, labelWindow.document.write(htmlLabel || '')];
                        }
                    }
                    // on failure
                    if (labelWindow) {
                        labelWindow.close();
                    }
                    if (fetchError) {
                        setRetryAvailable(false);
                        if ('code' in fetchError) {
                            errorInfo = getErrorBySSRCode(fetchError);
                            setAPIError(errorInfo);
                            return [2 /*return*/];
                        }
                        setAPIError({ type: 'TRYAGAIN', retryable: true });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    setRetryAvailable(true);
                    if (type === 'barcode')
                        return [2 /*return*/];
                    htmlLabel = createHtmlContent(returnLabelResponse, orderId);
                    if (isNativeApp) {
                        return [2 /*return*/, openNativeAppLabel(htmlLabel)];
                    }
                    if (labelWindow) {
                        return [2 /*return*/, labelWindow.document.write(htmlLabel || '')];
                    }
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var openNewReturnLabelWindow = function () {
        var newWindow = openNewWindow();
        if (!newWindow) {
            setAPIError({ type: 'TRYAGAIN', retryable: true });
            return null;
        }
        return newWindow;
    };
    useEffect(function () {
        if (apiError === null || apiError === void 0 ? void 0 : apiError.retryable) {
            var timeoutId_1 = setTimeout(function () {
                setRetryAvailable(true);
            }, 1000);
            return function () { return clearTimeout(timeoutId_1); };
        }
    }, [apiError === null || apiError === void 0 ? void 0 : apiError.retryable, retryAvailable]);
    return (React.createElement(ReturnLabelContext.Provider, { value: {
            orderId: orderId,
            loading: loading,
            lastClicked: lastClicked,
            fetchReturnLabel: fetchReturnLabel,
            returnLabelResponse: returnLabelResponse,
            apiError: apiError,
            setAPIError: setAPIError,
            error: error,
            retryAvailable: retryAvailable,
            setRetryAvailable: setRetryAvailable,
            openNewReturnLabelWindow: openNewReturnLabelWindow,
        } }, children));
};
